import React, { useState, useRef } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  StreetViewPanorama,
} from "@react-google-maps/api";

const mapContainerStyle = {
  width: "100%",
  height: "500px",
};

const center = { lat: 45.12064608237881, lng: -95.04795209742255 }; // Your given location

//45.12064608237881, -95.04795209742255
const MapComponent = () => {
  const [streetViewVisible, setStreetViewVisible] = useState(false);
  const [streetViewPosition, setStreetViewPosition] = useState(null);
  const mapRef = useRef(null);

  const onLoad = (map) => {
    mapRef.current = map;

    // Enable Pegman Drag & Drop
    const streetViewService = new window.google.maps.StreetViewService();
    const streetView = map.getStreetView();

    map.addListener("click", (event) => {
      streetViewService.getPanorama(
        { location: event.latLng, radius: 50 },
        (data, status) => {
          if (status === "OK") {
            setStreetViewVisible(true);
            setStreetViewPosition(event.latLng);
            streetView.setPosition(event.latLng);
            streetView.setVisible(true);
          }
        }
      );
    });
  };

  return (
    <LoadScript googleMapsApiKey="AIzaSyD2tYS4XweBP4_8kr5w5ypoQ3x-C_eGHjM">
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={center}
        zoom={15}
        onLoad={onLoad}
      >
        {/* Pinpoint Marker at Given Latitude & Longitude */}
        <Marker position={center} />

        {/* Street View Panorama (Only visible after Pegman is dropped) */}
        {streetViewVisible && (
          <StreetViewPanorama position={streetViewPosition} visible={true} />
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default MapComponent;
